// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionsCarousel-cls1_VVn","cls2":"SuggestionsCarousel-cls2_Fcg SuggestionsCarousel-cls1_VVn"};